import React from "react";
import styled from "styled-components";
import { FluidObject } from "gatsby-image";
import { internalPath, TrMetricsService } from "tr-web";
import { BackgroundImage } from "./Hero/BackgroundImage";
import BookNowButton from "../../shared/components/BookNowButton";

export interface HeroProps {
  title: string;
  subtitle: string;
  heroImageFluid?: FluidObject;
  heroButtonPath: string;
}

export function Hero({
  title,
  subtitle,
  heroImageFluid,
  heroButtonPath,
}: HeroProps) {
  const bookNowButtonPath = internalPath(heroButtonPath);
  const fireBookNowCtaClicked = () =>
    TrMetricsService.fire("location_service_cta_hero_book_now");

  return (
    <BackgroundImage fluid={heroImageFluid}>
      <HeroTextBoxMargin>
        <HeroTextBox>
          <HeroTitle>{title}</HeroTitle>
          <HeroSeparator />
          <HeroSubtitle>{subtitle}</HeroSubtitle>
          <BookNow
            href={bookNowButtonPath}
            onClick={fireBookNowCtaClicked}
            styledDisplay="block"
          />
        </HeroTextBox>
      </HeroTextBoxMargin>
    </BackgroundImage>
  );
}

const HeroTextBoxMargin = styled.div`
  padding-left: ${(props) => props.theme.spacing.md};
  padding-right: ${(props) => props.theme.spacing.md};
  padding-top: ${(props) => props.theme.spacing.xxxl};
  padding-bottom: ${(props) => props.theme.spacing.xxxl};
  min-height: 24rem;
  display: flex;
  align-items: center;
  ${(props) => props.theme.breakpoints.desktopUp} {
    min-height: 34rem;
    padding-left: ${(props) => props.theme.spacing.xxxl};
    padding-right: ${(props) => props.theme.spacing.xxxl};
  }
`;
const HeroTextBox = styled.div`
  padding-top: ${(props) => props.theme.spacing.md};
  padding-bottom: ${(props) => props.theme.spacing.lg};
  padding-left: ${(props) => props.theme.spacing.xl};
  padding-right: ${(props) => props.theme.spacing.xl};
  background-color: ${(props) => props.theme.color.white};
  min-height: 228px;
  max-width: 330px;
  width: auto;
  margin-left: auto;
  margin-right: auto;
  border-radius: ${(props) => props.theme.layout.borderRadius.md};
  text-align: center;
  ${(props) => props.theme.breakpoints.desktopUp} {
    padding-top: ${(props) => props.theme.spacing.xxl};
    padding-bottom: ${(props) => props.theme.spacing.xxl};
    max-width: initial;
    width: 568px;
  }
`;
const HeroTitle = styled.h1`
  font-size: ${(props) => props.theme.typography.typeScale[350]};
  font-weight: ${(props) => props.theme.typography.weight.extraBold};
  ${(props) => props.theme.breakpoints.desktopUp} {
    font-size: ${(props) => props.theme.typography.typeScale[600]};
  }
`;
const HeroSeparator = styled.div`
  width: 50px;
  border-top: 1px solid ${(props) => props.theme.color.accentSeparator};
  margin-top: ${(props) => props.theme.spacing.md};
  margin-bottom: ${(props) => props.theme.spacing.md};
  margin-left: auto;
  margin-right: auto;
  ${(props) => props.theme.breakpoints.desktopUp} {
    margin-top: ${(props) => props.theme.spacing.xl};
    margin-bottom: ${(props) => props.theme.spacing.xl};
  }
`;
const HeroSubtitle = styled.p`
  font-size: ${(props) => props.theme.typography.typeScale[300]};
  font-weight: ${(props) => props.theme.typography.weight.regular};
  margin-bottom: ${(props) => props.theme.spacing.lg};
  color: ${(props) => props.theme.color.black};
  ${(props) => props.theme.breakpoints.desktopUp} {
    font-size: ${(props) => props.theme.typography.typeScale[250]};
    margin-bottom: ${(props) => props.theme.spacing.xl};
  }
`;

const BookNow = styled(BookNowButton)`
  ${({ theme }) => theme.breakpoints.tabletUp} {
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
  ${({ theme }) => theme.breakpoints.desktopUp} {
    max-width: 50%;
    min-width: 200px;
    margin-left: auto;
    margin-right: auto;
  }
`;
